export default {
    name : 'vimeo',

    init()
    {
        this.run();
    },
    run ()
    {
        const elements = document.querySelectorAll('.video__container.vimeo');
        
        for (let i in elements) {

            if (typeof elements[i].dataset !== "undefined" && typeof elements[i].dataset.embed === "string" && elements[i].dataset.layerEmbed !== "true") {
                let iframe = '<iframe src="'+elements[i].dataset.embed+'" class="video__iframe border-radius" title="vimeo video" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="autoplay; fullscreen; picture-in-picture"></iframe>';
                elements[i].innerHTML = iframe;
            }
        }
    }
}